import { render, staticRenderFns } from "./ChangeCategory.vue?vue&type=template&id=0b3b18d6&scoped=true&"
import script from "./ChangeCategory.vue?vue&type=script&lang=js&"
export * from "./ChangeCategory.vue?vue&type=script&lang=js&"
import style0 from "./ChangeCategory.vue?vue&type=style&index=0&id=0b3b18d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3b18d6",
  null
  
)

export default component.exports